import React from 'react'
import ReferalNavBar from './ReferalNavBar'
import UserImg from '../../asstes/images.jpeg'
import { FaCopy, FaHistory, FaLongArrowAltUp, FaWallet } from 'react-icons/fa'
import { GiReceiveMoney } from "react-icons/gi";
import { RiExchangeFundsLine } from 'react-icons/ri';
import { SiFampay } from 'react-icons/si';
import RewardImg from '../../asstes/medal.png'
import { MdOutlinePayment, MdVerifiedUser } from 'react-icons/md';
import Footer from '../Footer/Footer'

import Paper from '@mui/material/Paper';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TablePagination from '@mui/material/TablePagination';
import TableRow from '@mui/material/TableRow';

const columns = [
  { id: 'srNo', label: 'Sr No', minWidth: 50 },
  { id: 'id', label: 'ID', minWidth: 100 },
  { id: 'address', label: 'Address', minWidth: 200 },
  { id: 'profit', label: 'Profit', minWidth: 100, align: 'right', format: (value) => `$${value.toFixed(2)}` },
  { id: 'loss', label: 'Loss', minWidth: 100, align: 'right', format: (value) => `$${value.toFixed(2)}` },
  { id: 'amount', label: 'Amount', minWidth: 100, align: 'right', format: (value) => `$${value.toFixed(2)}` },
];

function createData(srNo, id, address, profit, loss, amount) {
  return { srNo, id, address, profit, loss, amount };
}

const rows = [
  createData(1, 'ID001', '123 Main St', 5000, 2000, 3000),
  createData(2, 'ID002', '456 Maple Ave', 7000, 1000, 6000),
  createData(3, 'ID003', '789 Oak Dr', 2000, 500, 1500),
  createData(4, 'ID004', '321 Pine Ln', 8000, 3000, 5000),
  createData(5, 'ID005', '654 Elm St', 10000, 7000, 3000),
  createData(6, 'ID006', '987 Cedar Blvd', 3000, 1500, 1500),
  createData(7, 'ID007', '159 Birch Way', 4000, 2000, 2000),
  createData(8, 'ID008', '753 Walnut Ct', 6000, 2500, 3500),
  createData(9, 'ID009', '951 Chestnut St', 9000, 4000, 5000),
  createData(10, 'ID010', '357 Spruce Rd', 12000, 8000, 4000),
  createData(11, 'ID011', '258 Fir Ave', 5000, 2500, 2500),
  createData(12, 'ID012', '159 Redwood Ln', 7000, 3000, 4000),
  createData(13, 'ID013', '753 Palm Dr', 3000, 1000, 2000),
  createData(14, 'ID014', '951 Ash St', 10000, 5000, 5000),
  createData(15, 'ID015', '357 Cypress Rd', 8000, 3500, 4500),
];

const Referal = () => {
  const [page, setPage] = React.useState(0);
  const [rowsPerPage, setRowsPerPage] = React.useState(7);

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(+event.target.value);
    setPage(0);
  };
  return (
    <>
      <div className='Referal_Main_Section'>
        <ReferalNavBar />

        <div className='Referal_Details_section'>


          <section className='Referal_profile_section'>
            <div className='referal_User_profile'>
              <div className='User_profile_image'>
                <div className='Img_div'>
                  <img src={UserImg}></img>
                </div>
                <p className='p'>Id 786</p>
              </div>
              
                <div className='User_profile_Details '>
                  <p>ajay jangid</p>
                  <p>ajay@gmail.com</p>
                  <p>0x1Fb0C631dF78c4Bb72  <span> <FaCopy /></span></p>
                  <p>Invited 2024-4-20 by  <span className='Invied_id'> ID 0 <FaLongArrowAltUp /> </span></p>
                </div>
              
            </div>
            <div className='animated_copy_address'>
              <div className='referal_User_copy_address'>
                <div className='referal_copy_inside'>
                  <div className='referal_link'>
                    <p>ReferalLink</p>
                    <p className='Link'>https://short.link/ABCDF</p>
                  </div>
                  <div className='referal_copy'>
                    <p>Copy</p>
                  </div>
                </div>

              </div>
            </div>
          </section>

          <section className='Referal_invest_section'>
           <div className='Trasnaction_info'>
              <p>Transaction </p>
              <span>info ?</span>
            </div>
            <div className='Main_div'>
              <div className='InvestBox1'>
                <div className='Inesvt_Border_animation'>
                  <div className='Min_invest Invest_limits \'>
                    <div className='Inest_footer'>
                      <p>Max Limit</p>
                      <p className='Icons'><RiExchangeFundsLine /></p>
                    </div>
                    <div className='Center_div'>
                      <p>$250</p>
                    </div>

                  </div>
                </div>
                <div className='Inesvt_Border_animation'>
                  <div className='Max_invest Invest_limits \'>
                    <div className='Inest_footer'>
                      <p>Max Limit</p>
                      <p className='Icons'><RiExchangeFundsLine /></p>
                    </div>
                    <div className='Center_div'>
                      <p>$10,000</p>
                    </div>
                  </div>
                </div>
                <div className='Inesvt_Border_animation'>
                  <div className='Min_invest Invest_limits \'>
                    <div className='Inest_footer'>
                      <p>Total Transaction</p>
                      <p className='Icons'><SiFampay /></p>
                    </div>
                    <div className='Center_div'>
                      <p>$2,00,000</p>
                    </div>

                  </div>
                </div>
              </div>
              <div className='InvestBox2'>
                  <div className='Total_transcation'>
                    {/* <div className='Box'>
                    <p>Total transaction Limit</p>
                    <p>$2,00000000000</p>
                  </div> */}
                    <div className='Box'>
                      <p>Your Transaction</p>
                      <p>$10,000</p>
                    </div>
                  </div>
                <div className='transcation_input'>
                  <input className='InputBox' placeholder='Enter Here' type='number'></input>
                  <button className='InvestBTn'> 
                  <span>Invest <span><MdOutlinePayment /></span></span>
                  </button>
                </div>
              </div>
            </div>
          </section>

          <section className='User_rewards_section'>
            <div className='Reward_Border_animation'>
              <div className='User_address rewards Slider_animation'>
                <div className='Start'>
                  <div className='User_data'>
                    <p><FaWallet className='Wallet_icons_szie' /></p>
                    <p style={{ display: "flex", gap: "1rem" }}>&nbsp;&nbsp;0x1Fb0C631dF78c4Bb72  <span>
                      <FaCopy />
                    </span></p>
                  </div>
                  <div className='User_data'>
                    <p><MdVerifiedUser className='Wallet_icons_szie' /></p>
                    <p>&nbsp;&nbsp;ID 786 </p>
                  </div>

                </div>
              </div>
            </div>
            <div className='Reward_Border_animation'>
              <div className='User_team_reward rewards Slider_animation'>
                <div className='Reward_header'>
                  <p>Team Reward</p>
                  <img src={RewardImg}></img>
                </div>
                <div className='Reward_center'>
                  <p>$0</p>
                </div>
              </div>
            </div>
            <div className='Reward_Border_animation Slider_animation'>
              <div className='User_Own_reward rewards'>
                <div className='Reward_header'>
                  <p>Your Reward</p>
                  <img src={RewardImg}></img>
                </div>
                <div className='Reward_center'>
                  <p>$0</p>
                </div>
              </div>
            </div>

          </section>

          <section className='User_history_section'>
         
              <div className='History_footer'>
                <p>Transaction </p>
                <i>History <span><FaHistory /></span></i>
              </div>
            <div className='Table_border_animation'>
              <div className='User_history_main_banner'>
                <Paper sx={{ width: '100%', overflow: 'hidden' }}>
                  <TableContainer sx={{ maxHeight: 540 }}>
                    <Table stickyHeader aria-label="sticky table">
                      <TableHead>
                        <TableRow>
                          {columns.map((column) => (
                            <TableCell
                              sx={{ color: '#fff', background: "#212121",borderBottomColor:"1px solid #e0e0e03b" }}
                              key={column.id}
                              align={column.align}
                              style={{ minWidth: column.minWidth }}
                            >
                              {column.label}
                            </TableCell>
                          ))}
                        </TableRow>
                      </TableHead>
                      <TableBody>
                        {rows
                          .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                          .map((row) => {
                            return (
                              <TableRow hover role="checkbox" tabIndex={-1} key={row.code}>
                                {columns.map((column) => {
                                  const value = row[column.id];
                                  return (
                                    <TableCell sx={{ color: '#fff', background: "black" }} key={column.id} align={column.align}>
                                      {column.format && typeof value === 'number'
                                        ? column.format(value)
                                        : value}
                                    </TableCell>
                                  );
                                })}
                              </TableRow>
                            );
                          })}
                      </TableBody>
                    </Table>
                  </TableContainer>
                  <TablePagination
                    sx={{ color: '#fff', background: "#212121" }}
                    rowsPerPageOptions={[7, 14, 100]}
                    component="div"
                    count={rows.length}
                    rowsPerPage={rowsPerPage}
                    page={page}
                    onPageChange={handleChangePage}
                    onRowsPerPageChange={handleChangeRowsPerPage}
                  />
                </Paper>
              </div>
            </div>
          </section>

        </div>
        <Footer />
      </div>
    </>
  )
}

export default Referal